<!-- <all-projects *ngIf="oneTenant"></all-projects> -->

<div class="main-content" *ngIf="isToSelect">
  <div class="container-fluid">
      <div class="card sq-card">
        <div class="card-header card-header-squirrel">
            <h4 class="card-title">{{this.translate.data['SELECTTENANT'] | translate}}</h4>
          </div>


          <!-- <div class="card-header card-header-squirrel">
              <button matTooltip="{{this.translate.data['ADDTENANT'] | translate}}" mat-raised-button class="btn btn-squirrel pull-right" (click)="addTenant()" *ngIf="tenant">
                  <mat-icon>person_add</mat-icon>
              </button>
              <div class="clearfix"></div>
          </div> -->
          <!-- <div class="card-body" [ngSwitch]="gridView">
              <squirrel-data *ngSwitchCase="squirreldbView"></squirrel-data>
              <tenant-data *ngSwitchCase="tenantdbView"></tenant-data>               
          </div> -->
          <div class="card-body">                
              <!-- <div class="user-tenants-table"> -->
                <!-- <div class="user-tenants-table" style="max-height: 300px; overflow-y: auto;"> -->
                <div class="user-tenants-table" style="max-height: 100%; overflow-y: auto;">
                <ng-container *ngIf="!isLoadingResults">
                    <mat-option *ngFor="let tenant of userTenants" [value]="tenant" >
                        <div (click)="onRowClicked(tenant)" style="display:flex; align-items:center; justify-content:space-between; width:100%;">
                            <div style="float:left; width: 50%;">
                                {{tenant.displayName}}
                            </div>
                            <div style="float: left; width: 50%;">
                                <img *ngIf="tenant.image" [src]="'data:image/jpeg;base64,' + tenant.image" style="height:40px; object-fit:cover; border-radius:4px;">
                            </div>
                        </div>
                    </mat-option>

                    <!-- <mat-option *ngFor="let tenant of userTenants" [value]="tenant" >
                        <div (click)="onRowClicked(tenant)"
                                 style="display:flex; align-items:center; cursor:pointer; gap:12px;">
                            <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                {{tenant.displayName}}
                            </span>
                            <img class="tenantImage"
                                     *ngIf="tenant.image"
                                     [src]="'data:image/jpeg;base64,' + tenant.image"
                                     style="width:40px; height:40px; object-fit:cover;">
                        </div>
                    </mat-option> -->


                </ng-container>
      <!-- <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                      <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                      <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                          Squirrel's API rate limit has been reached. It will be reset in one minute.
                          
                      </div>
                  </div> -->

                  <!-- <ag-grid-angular class="ag-theme-balham" style="height: 100%; width: 100%; padding: 5px;"
                  [overlayLoadingTemplate]="overlayLoadingTemplate"
                  [gridOptions]="gridOptions"
                  (gridReady)="onGridReady($event)" 
                  (rowClicked)="onRowClicked($event)"
                  [frameworkComponents]="frameworkComponents"               
                  [animateRows]="true"
                  [rowData]="rowData">
                  </ag-grid-angular> -->

                </div>
            </div>            
        </div>
    </div>
</div>





